import { parseProduct as parseProductHelper } from "@coworker/utils/products.helper";

/**
 * parse product number
 * @param {string} string Anything resembling an IKEA product number, so ART12345678, 132.456.78, s12345678 and some more variants accepted.
 * @returns {[shortId:string, type:"ART"|"SPR"|""]}
 */
export function parseProduct(string = "") {
  const [shortId, type] = parseProductHelper(string);
  return [shortId, type || ""];
}
